import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import '../scss/index.scss';
import Color from '@tool/color';
import { CloseIcon20 } from '@styled/icon';
import { newRate } from '@tool/index';
import PDF from '../../../component/pdf';
import Title from '../../../component/title';
import HeadPdf from '../../../component/head-pdf';
import FootPdf from '../../../component/foot-pdf';
import moIndex from '../../../store/index';
import ChartPDF from './chart-pdf';
import Explain from './explain';
import Table from './table';
import moFreshYear from './store';

interface IProps {}
interface IState {}

const FreshYearPDF = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { industry } = moIndex;
  const { xData } = moFreshYear;

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <>
      {!isEmpty(xData) ? (
        <PDF>
          <section className="fresh-salary_101">
            <HeadPdf onetitle="人力资源核心指标" twotitle={industry.name} />
            <section className="content-101101">
              <section className="title-101101">
                <Title title="应届生起薪 - 按时间" bigTitle="人力指标" tag={industry.name} />
              </section>

              <ChartPDF />
              {xData.length > 0 ? <Table /> : null}
              {xData.length > 0 ? <Explain /> : null}

            </section>
            <FootPdf />
          </section>
        </PDF>
      ) : null}
    </>
  );
};

export default observer(FreshYearPDF);
